import React, { useEffect, useRef, useState } from 'react'
import { useSnackbar } from '../../../components/SnackbarProvider'
import { Box, Button, Grid, IconButton, CircularProgress } from '@mui/material'
import TextField from '../../../components/shared/TextField'
import { EditIcon } from '../../../components/Icons'
import baseUrl from '../../../config/baseUrl'

interface Props {
  phoneNumber: any
  token: any
  userId: any
}
const ContactNumber = ({ phoneNumber, token, userId }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [loading, setLoading] = useState(false)
  const [contactNumber, setContactNumber] = useState<any>(phoneNumber || '')
  const [editable, setEditable] = useState<boolean>(true) // false
  const showSnackbar = useSnackbar()

  useEffect(() => {
    setContactNumber(phoneNumber)
  }, [phoneNumber])

  const handleClick = () => {
    setEditable(false)
    if (inputRef.current) {
      inputRef.current?.focus()
    }
  }

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const currentValue = event.currentTarget.value
    setContactNumber(currentValue.trim())
  }

  const handleCancel = () => {
    setEditable(true)
    setContactNumber(phoneNumber)
  }

  const handleSave = async () => {
    // setContactNumber('')
    setLoading(true)
    try {
      if (contactNumber.length === 0) {
        showSnackbar('Enter Contact Number', 'info')
        // setEditable(false)
        setLoading(false)
        return
      }
      if (contactNumber.length > 10 || contactNumber.length < 10) {
        showSnackbar('Please Enter Valid Contact Number', 'info')
        // setEditable(false)
        setLoading(false)
        return
      }

      const response = await fetch(`${baseUrl}/api/users/ProfileUpdate1/${userId as string} `, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
        body: JSON.stringify({ PhoneNumber: contactNumber }),
      })

      const data = await response.json()

      if (data?.status) {
        sessionStorage.setItem('phone', data?.user?.PhoneNumber)
        showSnackbar(data?.message, 'success')
        setEditable(true)
      setLoading(false)
      } else {
        showSnackbar(data?.message, 'error')
        setEditable(true)
      setLoading(false)
      }
    } catch (error: any) {
      showSnackbar(error?.message, 'error')
      setEditable(true)
      setLoading(false)
    } 
  }

  // const checkLengthValue = contactNumber?.length > 0

  return (
    <>
      <Grid item xs={9.5} md={6}>
        <TextField
          inputRef={inputRef}
          label='Contact No.'
          placeholder='Enter Contact No.'
          name='contactNumber'
          value={contactNumber}
          onChange={handleChange}
          disabled={editable}
          type='number'
        />
      </Grid>
      <Grid item xs={2.5} md={6}>
        <Box display='flex' width={1} height={1} alignItems='center' flexWrap='wrap'>
          {/* {editable && checkLengthValue && (
            <IconButton sx={{ mt: 3.5, p: 1, color: 'primary.main' }} onClick={handleClick}>
              <EditIcon />
            </IconButton>
          )}
          {(!checkLengthValue || !(editable && !checkLengthValue)) && (
            <Button
              variant='outlined'
              sx={{ mt: 3.5, maxWidth: 71, height: 37, p: 0 }}
              onClick={handleSave}
            >
              Save
            </Button>
          )} */}
          {loading && <CircularProgress sx={{ mt: 3.5, p: 1, color: 'primary.main' }} />}
          {editable && (
            <IconButton sx={{ mt: 3.5, p: 1, color: 'primary.main' }} onClick={handleClick}>
              <EditIcon />
            </IconButton>
          )}
          {!editable && !loading && (
            <>
              <Button
                variant='outlined'
                sx={{ mt: 3.5, maxWidth: 71, height: 37, p: 0 }}
                onClick={handleCancel}
              >
                Cancel
              </Button>

              <Button
                variant='contained'
                sx={{ mt: 3.5, maxWidth: 71, ml: { xs: 0, sm: 2 }, height: 37, p: 0 }}
                onClick={handleSave}
              >
                Save
              </Button>
            </>
          )}
        </Box>
      </Grid>
    </>
  )
}

export default ContactNumber
